import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  card: {
    backgroundColor: designTokens.neutral.white,
    borderRadius: designTokens.borderRadius.lg,
    boxShadow: designTokens.shadow.base,
    padding: "28px",
    width: "100%",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: designTokens.spacing[3],
    marginBottom: designTokens.spacing[4],
  },
  titleGroup: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  title: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[1],
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: designTokens.primary[800],
    margin: "0",
  },
  subtitle: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
  },
  legend: {
    display: "flex",
    alignItems: "center",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    marginLeft: designTokens.spacing[4],
  },
  legendDot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    flexShrink: "0",
  },
  legendLabel: {
    fontSize: "13px",
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "320px",
  },
  emptyContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "320px",
    color: designTokens.neutral[400],
    fontSize: designTokens.fontSize.sm,
  },
  unavailableContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    height: "320px",
    paddingLeft: designTokens.spacing[6],
    paddingRight: designTokens.spacing[6],
    borderRadius: designTokens.borderRadius.md,
    border: `1px dashed ${designTokens.neutral[200]}`,
    color: designTokens.neutral[400],
    fontSize: designTokens.fontSize.sm,
  },
});
